(() => {
 if(customElements.get('ace-player-pack'))return;
 customElements.define('ace-player-pack',class extends HTMLElement {
 connectedCallback(){
  this.formId=this.dataset.form;
  this.submit=e=>{
   if(e.target.getAttribute('id')!==this.formId)return;
   this.querySelectorAll('[data-pack-trim]').forEach(x=>x.value=x.value.trim());
   const fields=Array.from(this.querySelectorAll('[data-pack-required]'));
   const invalid=fields.find(x=>!x.checkValidity());
   const error=this.querySelector('[data-pack-error]');
   if(invalid){
    e.preventDefault();e.stopImmediatePropagation();
    error.textContent='Enter the player’s last name, number and team name, and upload a logo if requested.';
    error.hidden=false;invalid.reportValidity();invalid.focus();
   }else error.hidden=true;
  };
  document.addEventListener('submit',this.submit,true);
 }
 disconnectedCallback(){document.removeEventListener('submit',this.submit,true);}
 });
})();